export default "__VITE_ASSET__d219758c__$_?component__"